import useTrackPageLoad from 'hooks/useTrackPageLoad';
import TableContainer from 'pages/headliner/TableContainer';
import { useCallback, useState } from 'react';
import TableCard from './TableCard';
import TablePageTitle from './TablePageTitle';
import { useSocialShareStatsByRss } from './useSocialShareStatsByRss';

type RssTableContainerProps = {};

const RssTableContainer: React.FC<RssTableContainerProps> = () => {
  useTrackPageLoad({ section: 'Studio', page: 'Podcasts', state: 'Populated' });

  const [podcastId, setPodcastId] = useState<string>();
  const [episodeId, setEpisodeId] = useState<string>();

  const handleBackClick = useCallback(() => {
    if (episodeId) {
      setEpisodeId(undefined);
    } else if (podcastId) {
      setPodcastId(undefined);
    }
  }, [podcastId, episodeId]);

  const { summaryStats, youtubeSummaryStats } = useSocialShareStatsByRss({
    podcastId,
    episodeId,
    // eslint-disable-next-line no-nested-ternary
    view: episodeId ? 'episode' : podcastId ? 'podcast' : 'allPodcasts',
  });

  return (
    <TableContainer
      title={
        <TablePageTitle
          {...{ podcastId, episodeId }}
          onBackClick={handleBackClick}
        />
      }
      socialStats={summaryStats}
      youTubeStats={youtubeSummaryStats}
    >
      <TableCard
        podcastId={podcastId}
        episodeId={episodeId}
        onSelectEpisode={setEpisodeId}
        onSelectPodcast={setPodcastId}
      />
    </TableContainer>
  );
};
export default RssTableContainer;
